import React from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated, getUser } from "../utils/auth";
import useAutoLogout from "../hooks/useAutoLogout";

const ProtectedRoute = ({ element, roles = [] }) => {
  useAutoLogout();

  const user = getUser();

  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  return element;
};

export default ProtectedRoute;
